import React, { useState, useEffect, Fragment } from 'react';
import Select from 'react-select';
import {
    Card,
    CardBody,
    Button,
    ButtonGroup,
    Col,
    CustomInput,
    FormGroup,
    Label,
    Modal,
    ModalBody, ModalFooter,
    ModalHeader,
    Input,
    CardImg,
    Row
} from 'reactstrap';

import ImageGallery from '../../../propinfo/gallery/index';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { SelectStyle } from '../../style/DigitalAssistantStyle';
let arr = [];
export default function PdfAttachment({
    pageSettings,
    saveIntegration,
    integration,
    allProperties,
    propertyId
}) {
    const [name, setName] = useState('');
    const [pdfTemplate, setPdfTemplate] = useState(pageSettings.pdfTemplate || 'SinglePageDesign1');
    const [isAivaHide, setIsAivaHide] = useState(integration.isaivaHide || false);
    const [showBusinessAddress, setShowBusinessAddress] = useState(pageSettings.showBusinessAddress || false);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [isGiftTemplateDesign,setIsGIftTemplateDesign]= useState(false);
    const [giftPdfTemplateSettings, setGiftTemplateSettings] = useState(pageSettings.giftPdfTemplateSettings || {
        pdfGiftTemplate: 'SinglePageDesign1',
        simplisticBackGround: '',
        singlePageDesign2BackGround: '',
        singlePageDesign2WithMessageBackGround: ''
    });
    const handleSave = () => {
        pageSettings.showBusinessAddress = showBusinessAddress;
        pageSettings.pdfTemplate = pdfTemplate;
        pageSettings.giftPdfTemplateSettings = giftPdfTemplateSettings;
        saveIntegration({ pageSettings: pageSettings, isaivaHide: isAivaHide });
    };
    const handleAivaChange = (e) => {
        setIsAivaHide(e.target.checked);
    }

    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={'avatar'}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const togglegallery = (val) => {
        setIsGIftTemplateDesign(val);
        setGalleryVisible(!galleryVisible);
    };

    const selectedImage = (image) => {
        if (isGiftTemplateDesign) {
            if (giftPdfTemplateSettings?.pdfGiftTemplate === 'SimplisticDesign')
                setGiftTemplateSettings({ ...giftPdfTemplateSettings, simplisticBackGround: image.src });
            else if (giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign2')
                setGiftTemplateSettings({ ...giftPdfTemplateSettings, singlePageDesign2BackGround: image.src });
            else if (giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign2WithMessage')
                setGiftTemplateSettings({ ...giftPdfTemplateSettings, singlePageDesign2WithMessageBackGround: image.src });
        } else {
            setGiftTemplateSettings({ ...giftPdfTemplateSettings, singlePageDesign2BackGround: image.src });
        }
    };
    return (
        <Fragment>
            <Card>
                <CardBody name="bodyClick text-center">
                    <h6 className='text-center'>Email & Attachment</h6>
                    <Separator className="mb-3" />
                    <div className='d-flex justify-content-left my-3'>
                        <CustomInput
                            type="checkbox"
                            id="aivaEnabled"
                            checked={isAivaHide}
                            name="aivaEnabled"
                            onChange={handleAivaChange}
                        >Make the voucher emails easy to recognize by replacing the sender’s name with "{allProperties.filter((m) => m.id === propertyId)[0].name}", otherwise shows as "aiva"</CustomInput>
                    </div>
                    <div className='d-flex justify-content-left my-3'>
                        <CustomInput
                            type="checkbox"
                            id="showBusinessAddress"
                            checked={showBusinessAddress}
                            name="showBusinessAddress"
                            onChange={() => setShowBusinessAddress(!showBusinessAddress)}
                        >Replace the business name and address in the email footer with your business address, otherwise shows as Myma.ai</CustomInput>
                    </div>
                    <div className='d-flex justify-content-left my-3'>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>
                                        <b className='mt-3 mr-2 text-center'>Select Voucher PDF Template (self use)</b>
                                    </Label>
                                    <select
                                        name="Pdf Template"
                                        type='select'
                                        style={SelectStyle}
                                        value={pdfTemplate}
                                        onChange={(e) => setPdfTemplate(e.target.value)}
                                    >
                                        <option value="SinglePageDesign1">Single page A4 landscape design #1</option>
                                        <option value="SinglePageDesign2">Single page A4 landscape design #2</option>
                                        <option value="MultiPageDesign">Multipage A4 portrait with details and full terms</option>

                                    </select>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label><b>View sample</b></Label> 
                                    <br/>
                                    <br/>                                   
                                    {pdfTemplate === 'SinglePageDesign1' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="https://assets.bookmebob.com/public/aivaVR6KHZXZU.pdf" target='_blank'>Single page A4 landscape design #1</a>}
                                    {pdfTemplate === 'SinglePageDesign2' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" target='_blank'>Single page A4 landscape design #2</a>}
                                    {pdfTemplate === 'MultiPageDesign' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" target='_blank'>Multipage A4 portrait with details and full terms</a>}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div className="text-center">                       
                        {pdfTemplate === 'SinglePageDesign2' &&
                            <CardImg
                                top
                                src={giftPdfTemplateSettings.singlePageDesign2BackGround}
                                alt="Card image cap"
                                style={{height:'150px'}}
                                className="img-thumbnail border-0 list-thumbnail"
                            />}

                        {pdfTemplate === 'SinglePageDesign2'  &&
                            <div className="mb-1">
                                <Button
                                    color="success"
                                    size="xs"
                                    className="mt-1"
                                    onClick={()=>togglegallery(false)}
                                >
                                    Browse Background
                                </Button>
                            </div>}
                    </div>
                    <div className='d-flex justify-content-left my-3'>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label><b className='mt-3 mr-2 text-center'>Select Gift PDF Template</b></Label>
                                    <select
                                        name="Pdf Template"
                                        type='select'
                                        style={SelectStyle}
                                        value={giftPdfTemplateSettings?.pdfGiftTemplate}
                                        onChange={(e) => setGiftTemplateSettings({...giftPdfTemplateSettings,pdfGiftTemplate: e.target.value})}
                                    >
                                        <option value="SinglePageDesign1">Single page A4 landscape design #1</option>
                                        <option value="SinglePageDesign1WithMessage">Single page A4 landscape design #1 with personal message</option>
                                        
                                        <option value="SinglePageDesign2WithMessage">Single page A4 landscape design #2 with personal message</option>

                                        <option value="SimplisticDesign">Simplistic 8.5x11 inch with personal message</option>
                                        <option value="MultiPageDesign">Multipage A4 portrait with details and full terms</option>


                                    </select>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label><b>View sample</b></Label>
                                    <br/>
                                    <br/>                                   
                                    {giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign1' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="https://assets.bookmebob.com/public/aivaVR6KHZXZU.pdf" target='_blank'>Single page A4 landscape design #1</a>}
                                    {giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign1WithMessage' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" target='_blank'>Single page A4 landscape design #1 with personal message</a>}
                                    {giftPdfTemplateSettings?.pdfGiftTemplate === 'MultiPageDesign' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" target='_blank'>Multipage A4 portrait with details and full terms</a>}
                                    {giftPdfTemplateSettings?.pdfGiftTemplate === 'SimplisticDesign' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" target='_blank'>Simplistic 8.5x11 inch with personal message</a>}
                                    {giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign2' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" target='_blank'>Single page A4 landscape design #2</a>}
                                    {giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign2WithMessage' &&
                                    <a style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" target='_blank'>Single page A4 landscape design #2 with personal message</a>}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>                    
                    <div className="text-center">
                        {giftPdfTemplateSettings?.pdfGiftTemplate === 'SimplisticDesign' &&
                            <CardImg
                                top
                                style={{height:'150px'}}
                                src={giftPdfTemplateSettings.simplisticBackGround}
                                alt="Card image cap"
                                className="img-thumbnail border-0 list-thumbnail"
                            />}
                    

                        {giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign2WithMessage' &&
                            <CardImg
                                top
                                style={{height:'150px'}}
                                src={giftPdfTemplateSettings.singlePageDesign2WithMessageBackGround}
                                alt="Card image cap"
                                className="img-thumbnail border-0 list-thumbnail"
                            />}

                        {(giftPdfTemplateSettings?.pdfGiftTemplate ==='SimplisticDesign' || giftPdfTemplateSettings?.pdfGiftTemplate === 'SinglePageDesign2WithMessage' ||
                            giftPdfTemplateSettings?.pdfGiftTemplate ==='SinglePageDesign2') &&

                            <div className="mb-1">
                                <Button
                                    color="success"
                                    size="xs"
                                    className="mt-1"
                                    onClick={()=>togglegallery(true)}
                                >
                                    Browse Background
                                </Button>
                            </div>}
                    </div>


                    <div className='d-flex justify-content-center mb-2'>
                        <ButtonGroup className="mb-2 text-center" style={{ marginTop: '40px' }}>
                            <Button color="primary" size="xs" outline onClick={handleSave}>
                                Save
                            </Button>
                        </ButtonGroup>
                    </div>

                    {ImageGalleryButton()}
                </CardBody>
            </Card>
        </Fragment>
    );
}
